import {Box, HStack, Icon, Link, Show, Space, Text, VStack} from 'platform/foundation';

import {isNotEmpty} from 'ramda';
import {isNotNil, isNotNilOrEmpty} from 'ramda-adjunct';

import {SellerResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {getSellerEmail} from '../utils/getSellerEmail';
import {getSellerMapUrl} from '../utils/getSellerMapUrl';
import {getSellerPhoneNumbers} from '../utils/getSellerPhoneNumbers';
import {SellerContactValue} from './SellerContactValue';

interface SellerProps extends TestIdProps {
  seller: SellerResponseBody;
}

export function Seller(props: SellerProps) {
  const phoneNumbers = getSellerPhoneNumbers(props.seller);
  const email = getSellerEmail(props.seller);
  const mapUrl = getSellerMapUrl(props.seller);
  const address = [props.seller.address, props.seller.city].filter(isNotNilOrEmpty).join(', ');

  return (
    <Box
      backgroundColor="palettes.neutral.20.100"
      borderRadius="medium"
      padding={4}
      data-testid={props['data-testid']}
    >
      <Text size="xSmall" color="secondary">
        {i18n.t('entity.sourcing.vehiclePreview.labels.dealer')}
      </Text>
      <Space vertical={2} />
      <Text alternative>{props.seller.name}</Text>
      <Show when={isNotNil(mapUrl)}>
        <Space vertical={2} />
        <Link
          size="small"
          leftIcon="communication/location_on"
          href={mapUrl}
          target="_blank"
          title={address}
          data-testid={suffixTestId('sellerAddress', props)}
        />
      </Show>
      <Show when={isNotEmpty(phoneNumbers)}>
        <Space vertical={6} />
        <HStack spacing={2} align="center">
          <Icon value="communication/phone" size={4} color="text.secondary" />
          <VStack>
            {phoneNumbers.map((phone, index) => (
              <SellerContactValue
                key={phone.label}
                contact={phone}
                data-testid={suffixTestId(`sellerPhone-[${index}]`, props)}
              />
            ))}
          </VStack>
        </HStack>
      </Show>
      <Show when={email}>
        {(sellerEmail) => (
          <>
            <Space vertical={2} />
            <HStack spacing={2} align="center">
              <Icon value="communication/email" size={4} color="text.secondary" />
              <SellerContactValue
                contact={sellerEmail}
                data-testid={suffixTestId('sellerEmail', props)}
              />
            </HStack>
          </>
        )}
      </Show>
    </Box>
  );
}
